import { render, staticRenderFns } from "./AssignmentConfig.vue?vue&type=template&id=ca153276"
import script from "./AssignmentConfig.vue?vue&type=script&lang=js"
export * from "./AssignmentConfig.vue?vue&type=script&lang=js"
import style0 from "./AssignmentConfig.vue?vue&type=style&index=0&id=ca153276&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports